import type { Direction } from "../../../engine/direction";
import { directionDelta } from "../../../engine/direction";
import { Particle } from "../particle";
import {
	colorGradient,
	deceleratingMotion,
	easeOut,
	lerp,
	randomAngle,
	randomBetween,
} from "../interpolation";

export class MissileExhaustParticle extends Particle {
	/** Emission interval for generators (ms between particles). */
	static readonly emitIntervalMs = 150;

	/** Spawn offset from entity center in cell units (shifts toward the nozzle). */
	static spawnOffset(direction?: Direction): { x: number; y: number } {
		if (!direction) return { x: 0, y: 0 };
		const delta = directionDelta(direction);
		return { x: -delta.x * 0.4, y: -delta.y * 0.4 };
	}

	constructor(originX: number, originY: number, direction?: Direction) {
		const delta = direction ? directionDelta(direction) : null;
		const backX = delta ? -delta.x : 0;
		const backY = delta ? -delta.y : 0;

		const mag = Math.sqrt(backX * backX + backY * backY);
		const normX = mag > 0 ? backX / mag : 0;
		const normY = mag > 0 ? backY / mag : 0;

		const speed = randomBetween(3, 4);
		const lateralSpread = randomBetween(-0.3, 0.3);
		const vx = normX * speed + -normY * lateralSpread;
		const vy = normY * speed + normX * lateralSpread;

		const startAngle = randomAngle();

		super(originX, originY, {
			ttl: randomBetween(700, 750),
			size: lerp(0.5, 0.1),
			opacity: easeOut(1, 1),
			color: colorGradient([
				{ r: 255, g: 220, b: 50 },
				{ r: 255, g: 120, b: 20 },
				{ r: 80, g: 80, b: 80 },
			]),
			rotation: lerp(startAngle, startAngle + 1.0),
			position: deceleratingMotion(vx, vy, 2.0),
		});
	}
}
